import { render, staticRenderFns } from "./InternetModal.vue?vue&type=template&id=6f749476&"
import script from "./InternetModal.vue?vue&type=script&lang=js&"
export * from "./InternetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports